<script src="../../../../config/index.js"></script>
<template>
  <!--  头部标签-->
  <div id="oneId">
    <div id="headerId">
      <img src="../../../assets/images/htyLogo.png">
      <ul>
        <li @click="toPath('/')" id="home">网站首页</li>
        <li class="cpjjfaClass" id="cpjjfaId">产品与解决方案<img src="../../../assets/images/selectIcon.png"/>
          <div class="selectMenuClass">
            <div class="lotServiceClass">
              <p>IoT服务</p>
              <div class="hrClass"></div>
              <span @click="toPath('/lotService')">车队管理</span>
              <span @click="toPath('/lotService',810)">数字货运</span>
            </div>
            <div class="wlServiceClass">
              <p>物流装备服务</p>
              <div class="hrClass"></div>
              <span @click="toPath('/logisticsService')">车前资产服务</span>
              <span @click="toPath('/logisticsService',840)">车后资产服务</span>
            </div>
            <div class="financialServiceClass">
              <p>金融服务</p>
              <div class="hrClass"></div>
              <span @click="toPath('/buyFinancial',0,1)">购车金融</span>
              <span @click="toPath('/theCarFinancial',0,2)">用车金融</span><br>
              <span @click="toPath('/productValueAdded',0,3)">增值产品</span>
            </div>
          </div>
        </li>
        <li @click="toPath('/customerCase')" id="customerCase" v-if="false">客户案例</li>
        <li @click="toPath('/newsCenter')" id="newsCenter">新闻中心</li>
        <li @click="toPath('/aboutUs',0,1)" id="aboutUs">关于我们</li>
        <li @click="toPath('/mail')" id="mail">董事长信箱</li>
      </ul>
      <div class="cpsyClass" @click="showDialog">产品试用</div>
    </div>
    <!--    产品预约弹出框-->
    <cpyyModal :showDialogData="showDialogData" :closeModal="closeModal" :fromObj="fromObj"
               :modal_loading="modal_loading" :add="add"/>
  </div>
</template>
<script>
import cpyyModal from "./cpyyModal";
import {RETCODE, SUCCESS} from "../../../assets/js/const";
import {cpyyModalMixins} from "../../../assets/mixins/cpyyModalMixins";

export default {
  mixins: [cpyyModalMixins],
  components: {
    cpyyModal
  },
  data() {
    return {
      menuData: [
        {
          id: 1,
          menuName: '网站首页',
          check: true,
          path: '/'
        },
        {
          id: 2,
          menuName: '产品与解决方案',
          check: true,
          childMenuData: [
            {
              id: 21,
              menuName: 'IoT服务',
              menuChildData: [
                {
                  id: 211,
                  menuName: '车队管理',
                  path: '/lotService',
                  topNum: 0
                },
                {
                  id: 212,
                  menuName: '数字货运',
                  path: '/lotService',
                  topNum: 810
                }
              ]
            },
            {
              id: 22,
              menuName: '物流装备服务',
              menuChildData: [
                {
                  id: 221,
                  menuName: '车前资产服务',
                  path: '/logisticsService'
                },
                {
                  id: 222,
                  menuName: '车后资产服务',
                  path: '/logisticsService'
                }
              ]
            },
            {
              id: 23,
              menuName: '金融服务',
              menuChildData: [
                {
                  id: 231,
                  menuName: '购车金融',
                  path: '/buyFinancial'
                },
                {
                  id: 232,
                  menuName: '用车金融',
                  path: '/theCarFinancial'
                },
                {
                  id: 233,
                  menuName: '二手车金融',
                  path: '/productValueAdded'
                },
                {
                  id: 234,
                  menuName: '供应链金融',
                  path: '/financialService'
                }
              ]
            }
          ]
        },
        {
          id: 3,
          menuName: '客户案例',
          check: true,
          path: '/customerCase'
        },
        {
          id: 4,
          menuName: '新闻中心',
          check: true,
          path: '/newsCenter'
        },
        {
          id: 5,
          menuName: '关于我们',
          check: true,
          path: '/aboutUs'
        },
        {
          id: 6,
          menuName: '董事长信箱',
          check: true,
          path: '/mail'
        }
      ],
    }
  },
  watch: {
    $route(to, from) {
      let _className = '', fromClassName = ''
      switch (from.path) {
        case '/':
          fromClassName = 'home';
          break;
        case '/customerCase':
        case '/customerCaseDetail':
          fromClassName = 'customerCase';
          break;
        case '/newsCenter':
        case '/newsCenterDetail':
          fromClassName = 'newsCenter';
          break;
        case '/abstract':
        case '/teamManage':
        case '/joinUs':
          fromClassName = 'aboutUs';
          break;
        case '/mail':
          fromClassName = 'mail';
          break;
        default:
          fromClassName = 'cpjjfaId';
          break;
      }
      document.getElementById(fromClassName).style.color = ''
      switch (to.path) {
        case '/':
          _className = 'home';
          break;
        case '/customerCase':
        case '/customerCaseDetail':
          _className = 'customerCase';
          break;
        case '/newsCenter':
        case '/newsCenterDetail':
          _className = 'newsCenter';
          break;
        case '/abstract':
        case '/teamManage':
        case '/joinUs':
          _className = 'aboutUs';
          break;
        case '/mail':
          _className = 'mail';
          break;
        default:
          _className = 'cpjjfaId';
          break;
      }
      document.getElementById(_className).style.color = '#4C61D8'
    }
  },
  methods: {
    toPath(to, topNum = 0, pathId) {
      this.$router.push({
        path: to,
        query: {
          topNum,
          pathId
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>

.cpjjfaClass:hover .selectMenuClass, .selectMenuClass:hover {
  display: flex !important;
}

.selectMenuClass {
  background-color: #EAEDF2;
  display: none;
  justify-content: center;
  padding: 48px 0;
  position: absolute;
  top: 98px;
  z-index: 9999;
  width: 100%;
  left: 0;
  box-shadow: 0px 5px 20px 0px rgb(0 0 0 / 5%);

  .lotServiceClass span:nth-child(3), .financialServiceClass span:nth-child(3) {
    margin-right: 64px;
  }

  .wlServiceClass span:nth-child(3) {
    margin-right: 20px;
  }

  .financialServiceClass span:nth-child(6) {
    margin-right: 50px;
  }

  .financialServiceClass {
    margin-right: 0 !important;
  }

  .lotServiceClass, .wlServiceClass, .financialServiceClass {
    width: 220px;
    margin-right: 79.5px;

    p {
      font-size: 20px;
      font-weight: 400;
      color: #333;
    }

    .hrClass {
      width: 220px;
      border: 1px solid #C0C8D5;
      margin-top: 24px;
    }

    span {
      font-size: 16px;
      font-weight: 400;
      color: #666;
      margin-top: 24px;
      display: inline-block;
    }

    span:hover {
      cursor: pointer;
      color: #4C61D8;
    }
  }
}

#oneId {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}

#headerId {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 999;
  //background-color: #FFF;
  box-shadow: 0px 5px 20px 0px rgb(0 0 0 / 5%);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: saturate(180%) blur(20px);

  img {
    width: 184px;
    height: 57px;
    margin-right: 55.5px;
  }

  .cpsyClass {
    font-size: 18px;
    font-weight: 400;
    color: #fff;
    padding: 16px 19px;
    background-color: #000;
    margin-left: 44px;
  }

  .cpsyClass:hover {
    cursor: pointer;
  }

  ul {
    display: flex;
    width: 906.5px;
    justify-content: space-around;
    align-items: center;

    li {
      height: 98px;
      font-size: 18px;
      font-weight: 400;
      color: #333;
      display: flex;
      align-items: center;
      list-style: none;
    }

    .cpjjfaClass img {
      width: 12px;
      height: 8px;
      margin-left: 11px;
      margin-right: 0 !important;
    }

    li:hover {
      color: #4C61D8;
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/pc/header/header.vue